// extracted by mini-css-extract-plugin
export default {"outerWrapper":"ImageComparisonFrame_outerWrapper__KJbE5","innerWrapper":"ImageComparisonFrame_innerWrapper__x92Sj","image":"ImageComparisonFrame_image__eqR6s"};